import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import InstantQuoteCTA from "@/components/InstantQuoteCTA";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Star, Quote, MessageSquarePlus } from "lucide-react";
import { Helmet } from "react-helmet-async";
import testimonialsHero from "@/assets/testimonials-hero-audi.jpg";
import googleReview from "@/assets/google-review.png";
import chauffeurService from "@/assets/chauffeur-service.webp";
const Testimonials = () => {
  const reviews = [{
    name: "Sarah Johnson",
    date: "2 weeks ago",
    rating: 5,
    text: "Exceptional service! Rick was professional, punctual, and the vehicle was immaculate. Made our airport transfer stress-free and comfortable. Highly recommend!"
  }, {
    name: "Michael Chen",
    date: "1 month ago",
    rating: 5,
    text: "Used Rick's service for a corporate event and couldn't be happier. The attention to detail and professionalism was outstanding. Will definitely use again."
  }, {
    name: "Jennifer Martinez",
    date: "1 month ago",
    rating: 5,
    text: "Amazing experience from start to finish! The car was luxurious, the driver was courteous, and the service exceeded all expectations. Perfect for special occasions."
  }, {
    name: "David Thompson",
    date: "2 months ago",
    rating: 5,
    text: "Best black car service in San Antonio! Always on time, always professional. Rick truly cares about his clients and it shows in every detail."
  }, {
    name: "Lisa Anderson",
    date: "2 months ago",
    rating: 5,
    text: "Impeccable service! Used for multiple airport transfers and every time has been flawless. The vehicles are pristine and the drivers are top-notch professionals."
  }, {
    name: "Robert Williams",
    date: "3 months ago",
    rating: 5,
    text: "Outstanding luxury transportation! Made our wedding day even more special. Highly recommended for anyone looking for premium car service in San Antonio."
  }, {
    name: "Emily Davis",
    date: "3 months ago",
    rating: 5,
    text: "Professional, reliable, and comfortable. Rick's Black Car Service is my go-to for all business travel. Never disappoints!"
  }, {
    name: "James Miller",
    date: "4 months ago",
    rating: 5,
    text: "Excellent service! The driver was friendly and knowledgeable about the area. The vehicle was spotless and the ride was smooth. Five stars all the way!"
  }, {
    name: "Amanda Garcia",
    date: "4 months ago",
    rating: 5,
    text: "Rick's service is simply the best! From booking to drop-off, everything was seamless. The luxury experience at reasonable rates. Highly recommend!"
  }, {
    name: "Christopher Lee",
    date: "5 months ago",
    rating: 5,
    text: "Top-tier service! Used for a special anniversary dinner and Rick made it memorable. Professional, punctual, and the car was stunning."
  }, {
    name: "Michelle Brown",
    date: "5 months ago",
    rating: 5,
    text: "Fantastic experience! The attention to detail and customer service is unmatched. Will definitely be using Rick's service for all future transportation needs."
  }, {
    name: "Daniel Rodriguez",
    date: "6 months ago",
    rating: 5,
    text: "Exceptional luxury service! Rick is professional and accommodating. The vehicles are pristine and the overall experience is first-class."
  }];
  return <div className="min-h-screen">
      <Helmet>
        <title>Testimonials | Rick's Black Car Service San Antonio</title>
        <meta name="description" content="Read reviews from satisfied clients of Rick's Black Car Service. 24 five-star Google reviews. Professional luxury transportation in San Antonio." />
        <link rel="canonical" href="https://ricksblackcarservicesantonio.com/testimonials/" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Testimonials | Rick's Black Car Service San Antonio" />
        <meta property="og:description" content="Read reviews from satisfied clients. 24 five-star Google reviews for luxury transportation in San Antonio." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ricksblackcarservicesantonio.com/testimonials" />
        
        {/* Schema.org Review Markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Rick's Black Car Service",
            "image": "https://ricksblackcarservicesantonio.com/og-image.jpg",
            "telephone": "+1-210-296-7409",
            "email": "ricksblackcarservice@outlook.com",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "San Antonio",
              "addressLocality": "San Antonio",
              "addressRegion": "TX",
              "postalCode": "78258",
              "addressCountry": "US"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5",
              "bestRating": "5",
              "worstRating": "1",
              "ratingCount": "24"
            },
            "review": reviews.map((review, index) => ({
              "@type": "Review",
              "itemReviewed": {
                "@type": "LocalBusiness",
                "name": "Rick's Black Car Service"
              },
              "author": {
                "@type": "Person",
                "name": review.name
              },
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": review.rating.toString(),
                "bestRating": "5",
                "worstRating": "1"
              },
              "reviewBody": review.text,
              "datePublished": new Date(Date.now() - (index + 1) * 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
            }))
          })}
        </script>
      </Helmet>
      <Navbar />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `url(${testimonialsHero})`
        }}>
            <div className="absolute inset-0 bg-gradient-to-r from-background/70 via-background/55 to-background/70" />
          </div>
          
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center space-y-6">
              <div className="flex items-center justify-center gap-3 mb-4">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-12 h-12 md:w-14 md:h-14 fill-primary text-primary animate-twinkle drop-shadow-[0_0_20px_hsl(var(--primary))] filter brightness-125" style={{
                animationDelay: `${i * 0.2}s`
              }} />)}
              </div>
              <h1 className="text-5xl md:text-7xl font-serif font-bold text-foreground">
                Client Testimonials
              </h1>
              <p className="text-xl md:text-2xl text-muted-foreground">
                Discover why our clients trust Rick's Black Car Service for their luxury transportation needs
              </p>
              <div className="pt-4">
                <span className="text-3xl font-bold text-primary">24</span>
                <span className="text-xl text-muted-foreground ml-2">Five-Star Google Reviews</span>
              </div>
              <div className="pt-6">
                <Button asChild className="text-lg px-8 py-6">
                  <a 
                    href="https://search.google.com/local/writereview?placeid=ChIJk-AbiuaLXIYRftOK6TBjJQI" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    aria-label="Leave a review for Rick's Black Car Service on Google"
                    className="google-review-glow"
                    style={{
                      backgroundColor: '#4285f4',
                      color: 'white',
                      borderRadius: '6px',
                      padding: '12px 24px',
                      transition: 'background-color 0.2s ease',
                      border: 'none',
                      position: 'relative',
                      display: 'inline-flex',
                      alignItems: 'center'
                    }} 
                    onMouseEnter={e => {
                      e.currentTarget.style.backgroundColor = '#3367d6';
                      e.currentTarget.style.animationPlayState = 'paused';
                    }} 
                    onMouseLeave={e => {
                      e.currentTarget.style.backgroundColor = '#4285f4';
                      e.currentTarget.style.animationPlayState = 'running';
                    }}
                  >
                    <MessageSquarePlus className="w-5 h-5 mr-2" />
                    Leave a Google Review
                  </a>
                </Button>
                <style>{`
                  @keyframes clockwise-glow {
                    0% {
                      box-shadow: 
                        0 2px 4px rgba(0, 0, 0, 0.1),
                        0 -20px 40px rgba(66, 133, 244, 0.6),
                        20px 0 40px rgba(66, 133, 244, 0.2),
                        0 20px 40px rgba(66, 133, 244, 0.2),
                        -20px 0 40px rgba(66, 133, 244, 0.2);
                    }
                    25% {
                      box-shadow: 
                        0 2px 4px rgba(0, 0, 0, 0.1),
                        0 -20px 40px rgba(66, 133, 244, 0.2),
                        20px 0 40px rgba(66, 133, 244, 0.6),
                        0 20px 40px rgba(66, 133, 244, 0.2),
                        -20px 0 40px rgba(66, 133, 244, 0.2);
                    }
                    50% {
                      box-shadow: 
                        0 2px 4px rgba(0, 0, 0, 0.1),
                        0 -20px 40px rgba(66, 133, 244, 0.2),
                        20px 0 40px rgba(66, 133, 244, 0.2),
                        0 20px 40px rgba(66, 133, 244, 0.6),
                        -20px 0 40px rgba(66, 133, 244, 0.2);
                    }
                    75% {
                      box-shadow: 
                        0 2px 4px rgba(0, 0, 0, 0.1),
                        0 -20px 40px rgba(66, 133, 244, 0.2),
                        20px 0 40px rgba(66, 133, 244, 0.2),
                        0 20px 40px rgba(66, 133, 244, 0.2),
                        -20px 0 40px rgba(66, 133, 244, 0.6);
                    }
                    100% {
                      box-shadow: 
                        0 2px 4px rgba(0, 0, 0, 0.1),
                        0 -20px 40px rgba(66, 133, 244, 0.6),
                        20px 0 40px rgba(66, 133, 244, 0.2),
                        0 20px 40px rgba(66, 133, 244, 0.2),
                        -20px 0 40px rgba(66, 133, 244, 0.2);
                    }
                  }
                  
                  .google-review-glow {
                    animation: clockwise-glow 2s linear infinite;
                  }
                  
                  .google-review-glow:active {
                    transform: scale(0.98) !important;
                  }
                `}</style>
              </div>
            </div>
          </div>
        </section>

        {/* Reviews Section */}
        <section className="py-20 luxury-gradient">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {reviews.map((review, index) => <Card key={index} className="card-luxury hover:scale-105 transition-transform duration-300">
                  <CardContent className="p-6 space-y-4">
                    <div className="flex items-center justify-between">
                      <div className="flex gap-1">
                        {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-primary text-primary" />)}
                      </div>
                      <Quote className="w-8 h-8 text-primary/30" />
                    </div>
                    
                    <p className="text-foreground leading-relaxed">
                      {review.text}
                    </p>
                    
                    <div className="pt-4 border-t border-border/50">
                      <p className="font-semibold text-foreground">{review.name}</p>
                      <p className="text-sm text-muted-foreground">{review.date}</p>
                    </div>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-20 overflow-hidden">
          <div 
            className="absolute inset-0 bg-cover bg-center" 
            style={{
              backgroundImage: `url(${chauffeurService})`,
              opacity: 0.9,
              filter: 'brightness(1.15)'
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-background/80 via-background/70 to-background/80" />
          </div>
          
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-3xl mx-auto text-center space-y-6">
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]">
                Experience the Difference
              </h2>
              <p className="text-lg text-muted-foreground drop-shadow-[0_2px_8px_rgba(0,0,0,0.4)]">
                Join our satisfied clients and discover why Rick's Black Car Service is San Antonio's premier luxury transportation provider.
              </p>
            </div>
          </div>
        </section>

        {/* Instant Quote CTA */}
        <InstantQuoteCTA />
      </main>
      <Footer />
    </div>;
};
export default Testimonials;